import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
} from '@angular/core';

@Directive({
  selector: 'video[appLazyVideoSource]',
  standalone: true,
})
export class LazyVideoSourceDirective implements AfterViewInit, OnChanges, OnDestroy {
  @Input() appLazyVideoSource = '';

  private observer: IntersectionObserver | null = null;
  private isLoaded = false;

  constructor(private elementRef: ElementRef<HTMLVideoElement>) {}

  ngAfterViewInit(): void {
    this.observe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['appLazyVideoSource']) {
      return;
    }

    this.isLoaded = false;
    const video = this.elementRef.nativeElement;
    video.removeAttribute('src');
    video.load();
    this.observe();
  }

  ngOnDestroy(): void {
    this.disconnect();
  }

  private observe(): void {
    this.disconnect();

    if (!this.appLazyVideoSource || this.isLoaded) {
      return;
    }

    if (!('IntersectionObserver' in window)) {
      this.load();
      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          this.load();
        }
      },
      { rootMargin: '400px 0px' }
    );
    this.observer.observe(this.elementRef.nativeElement);
  }

  private load(): void {
    if (this.isLoaded || !this.appLazyVideoSource) {
      return;
    }

    const video = this.elementRef.nativeElement;
    video.src = this.appLazyVideoSource;
    video.load();
    this.isLoaded = true;
    this.disconnect();
  }

  private disconnect(): void {
    this.observer?.disconnect();
    this.observer = null;
  }
}
